import Designer from 'components/Designer'

export default Designer
